import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import API from '../../services/API';
import Utils from '../../services/utils';

const initialState = {
  data: [],
  blink: [],
  filters: [],
  filteredPosts: [],
};

export const getAssetClasses = createAsyncThunk(
  'assets/retrieve',
  async () => {
    const res = await API.getAssetClasses();

    return res.map(r => ({
      name: r.name,
      groups: r.groups.map(g => ({
        name: g.name,
        underlyingList: Utils.asignColorsToItems(g.underlyingList),
      })),
    }));
  },
);

const appSlice = createSlice({
  name: 'assetClasses',
  initialState,
  reducers: {
    setSelectedFilters: {
      reducer(state, action) {
        state.filters = state.filters.map(filter => {
          if (filter.id === action.payload) {
            filter.checked = !filter.checked;
          }
          return filter;
        });
      },
    },
    setFilteredPosts: {
      reducer(state, action) {
        state.filteredPosts = action.payload.filter(blog => current(state).filters.some(filter => blog.assetClasses.some(assetClass => assetClass === filter.name) && filter.checked));
      },
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAssetClasses.fulfilled, (state, action) => {
      state.blink = Utils.getChangedTickers(state.data, action.payload);
      state.data = action.payload;
      if (state.filters.length === 0) {
        state.filters = action.payload.map((f, i) => ({
          name: f.name,
          checked: false,
          id: i,
        }));
        state.filters.push({ name: 'Fixed Income', id: 3, checked: false });
      }
    });
  },
});

const { reducer } = appSlice;
export const { setSelectedFilters, setFilteredPosts } = appSlice.actions;
export default reducer;
